exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-issues-1-js": () => import("./../../../src/pages/issues-1.js" /* webpackChunkName: "component---src-pages-issues-1-js" */),
  "component---src-pages-issues-2-js": () => import("./../../../src/pages/issues-2.js" /* webpackChunkName: "component---src-pages-issues-2-js" */),
  "component---src-pages-issues-3-js": () => import("./../../../src/pages/issues-3.js" /* webpackChunkName: "component---src-pages-issues-3-js" */)
}

